import { render, staticRenderFns } from "./deptuser.vue?vue&type=template&id=1bdbf927&scoped=true"
import script from "./deptuser.vue?vue&type=script&lang=js"
export * from "./deptuser.vue?vue&type=script&lang=js"
import style0 from "./deptuser.vue?vue&type=style&index=0&id=1bdbf927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdbf927",
  null
  
)

export default component.exports